export default __webpack_public_path__ + "static/media/retiroFallido.cd728784.jpg";